import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DocumentsEmptyState } from '@fluentsms/agentnet-web-icons';
import { Box, Button, createStyles, makeStyles, Typography } from '@material-ui/core';
const useStyles = makeStyles((theme) => createStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        width: '100%',
    },
    iconContainer: {
        marginBottom: theme.spacing(2),
        '& svg': {
            width: 250,
            height: 120,
        },
    },
    header: {
        marginBottom: theme.spacing(1),
    },
    description: {
        marginBottom: theme.spacing(2),
        color: theme.palette.text.secondary,
        maxWidth: 640,
    },
    buttonContainer: {
        display: 'flex',
        gap: theme.spacing(2),
        justifyContent: 'center',
        flexWrap: 'wrap',
    },
}));
export const EmptyState = ({ icon = _jsx(DocumentsEmptyState, {}), headerText, descriptionText, primaryButtonProps, secondaryButtonProps, }) => {
    const classes = useStyles();
    return (_jsxs(Box, { className: classes.root, children: [icon && _jsx(Box, { className: classes.iconContainer, children: icon }), _jsx(Typography, { variant: 'h4', component: 'h2', className: classes.header, children: headerText }), _jsx(Typography, { variant: 'body1', className: classes.description, children: descriptionText }), (primaryButtonProps || secondaryButtonProps) && (_jsxs(Box, { className: classes.buttonContainer, children: [primaryButtonProps && (_jsx(Button, { variant: primaryButtonProps.variant ?? 'contained', color: primaryButtonProps.color ?? 'primary', onClick: primaryButtonProps.onClick, disabled: primaryButtonProps.disabled ?? false, size: 'small', children: primaryButtonProps.label })), secondaryButtonProps && (_jsx(Button, { variant: secondaryButtonProps.variant ?? 'outlined', color: secondaryButtonProps.color ?? 'default', onClick: secondaryButtonProps.onClick, disabled: secondaryButtonProps.disabled ?? false, size: 'small', children: secondaryButtonProps.label }))] }))] }));
};
